import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const ShareCTA = dynamic(() => import('./ShareCTA').then((m) => ({ default: m.ShareCTA })));

const ShareCTAConfig = {
  name: 'ShareCTA',
  friendlyName: 'Share CTA',
  inputs: [
    {
      name: 'overline',
      type: 'string',
      friendlyName: 'Overline Text',
      helperText: 'Small text displayed above the heading in the primary/orange color',
      defaultValue: 'Found this useful?',
      required: false,
    },
    {
      name: 'heading',
      type: 'string',
      friendlyName: 'Heading',
      helperText: 'Main heading displayed in white on the purple background',
      defaultValue: 'Share Tempcover with a friend or save for later',
      required: false,
    },
  ],
};

Builder.registerComponent(ShareCTA, ShareCTAConfig);
